// import { useAsyncStorage } from '@react-native-community/async-storage';
import React, { useMemo, useContext } from 'react';

type ThemeContextProps = {
  toggleTheme: (...args: any[]) => any;
  theme: any
}

const ThemeContext = React.createContext<ThemeContextProps | undefined>(undefined);

type Props = {
	theme: string;
	toggleTheme: (...args: any[]) => any;
	children: React.ReactNode | React.ReactNode[];
};

function ThemeSwitchProvider({ children, theme, toggleTheme }: Props) {
	const defaultValue = useMemo(
		() => ({
			toggleTheme,
			theme,
		}),
		[theme, toggleTheme]
	);
	return <ThemeContext.Provider value={defaultValue}>{children}</ThemeContext.Provider>;
}

function useThemeSwitch() {
	const context = useContext(ThemeContext);
	if (context === undefined) {
		throw new Error(`useThemeSwitch must be used within a ThemeSwitchProvider`);
	}
	return context;
}

export { ThemeSwitchProvider, useThemeSwitch };
